import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'naoInformado'
})
export class NaoInformadoPipe implements PipeTransform {
    transform(value: any) {
        if (value) {
            return value
        }

        return '<span class="text-muted">Não informado</span>'
    }
}



// WEBPACK FOOTER //
// ./src/app/common/nao-informado.pipe.ts